import React  from "react";
import { useParams } from 'react-router-dom';
import InvoiceForm from "./components/InvoiceForm";

const ViewInvoice = () => {

	const { invoiceId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<InvoiceForm recordId={invoiceId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default ViewInvoice;